import type { Column } from 'react-table';
import { Chip, styled, Typography } from '@mui/material';
import { ContextMenuButton, TableCell, TableHeader } from 'redesign';
import { IconFlexPoolOnlyJob } from 'assets/img';
import { useTranslation } from 'react-i18next';
import { CancelledCellProps, CancelledColumnDefinition } from './cancelled-table.types';
import { useGetShiftDetailsColumnDefinitionBase } from '../../shared/columns/use-get-shift-details-column-definition-base';
import { ArchiveTableColumnDefinition } from '../../../../../../../ogp/components/views/administration';

export const useGetCancelledColumnDefinition: () => Column<CancelledColumnDefinition>[] = () => {
  const [flexWorkerImage, fw] = useGetShiftDetailsColumnDefinitionBase();
  const { t } = useTranslation('hq-screen-specific');

  const cancellationReason: Column<CancelledColumnDefinition> = {
    Header: '',
    accessor: 'cancellationReason',
    Cell: CancellationReasonCell,
  };

  const flexPoolIndicator: Column<CancelledColumnDefinition> = {
    Header: '',
    accessor: 'flexPoolIndicator',
    Cell: FlexPoolIndicatorCell,
  };
  const hourlyRate: Column<CancelledColumnDefinition> = {
    Header: () => (
      <TableHeader>
        {t('shifts.cancellations.table_headers.hourly_rate', { ns: 'hq-screen-specific' })}
      </TableHeader>
    ),
    accessor: 'hourlyRate',
    Cell: HourlyRateCell,
  };

  const actions: Column<ArchiveTableColumnDefinition> = {
    accessor: 'actions',
    Header: '',
    Cell: ActionCell,
  };

  return [flexWorkerImage, cancellationReason, flexPoolIndicator, fw, hourlyRate, actions];
};

const HourlyRateCell = ({ value }: CancelledCellProps<'hourlyRate'>) => {
  return (
    <TableCell>
      {value.toLocaleString('nl-NL', {
        style: 'currency',
        currency: 'EUR',
      })}
    </TableCell>
  );
};

const FlexPoolIndicatorCell = ({ value }: CancelledCellProps<'flexPoolIndicator'>) => {
  return value ? <IconFlexPoolOnlyJob width={24} /> : null;
};

const CancellationReasonCell = ({ value }: CancelledCellProps<'cancellationReason'>) => {
  return <StyledChip size="small" label={<Typography variant="body2">{value}</Typography>} />;
};

const ActionCell = ({ value, getRowActions }: CancelledCellProps<'actions'>) => {
  const actions = getRowActions(value);

  if (actions.length === 0) {
    return null;
  }

  return (
    <ContextMenuButton menuId={`cancelled-actions-menu-${value.workerId}`}>
      {actions}
    </ContextMenuButton>
  );
};

const StyledChip = styled(Chip)(({ theme }) => ({
  backgroundColor: theme.palette.warning.main,
}));
